/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inquiryClientControllerCreateV1 } from '../fn/inquiry-client/inquiry-client-controller-create-v-1';
import { InquiryClientControllerCreateV1$Params } from '../fn/inquiry-client/inquiry-client-controller-create-v-1';
import { inquiryClientControllerFindByIdV1 } from '../fn/inquiry-client/inquiry-client-controller-find-by-id-v-1';
import { InquiryClientControllerFindByIdV1$Params } from '../fn/inquiry-client/inquiry-client-controller-find-by-id-v-1';
import { inquiryClientControllerSearchV1 } from '../fn/inquiry-client/inquiry-client-controller-search-v-1';
import { InquiryClientControllerSearchV1$Params } from '../fn/inquiry-client/inquiry-client-controller-search-v-1';
import { InquiryDto } from '../models/inquiry-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class InquiryClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inquiryClientControllerSearchV1()` */
  static readonly InquiryClientControllerSearchV1Path = '/api/v1/inquiries/client';

  /**
   * 문의 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryClientControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryClientControllerSearchV1$Response(params: InquiryClientControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = inquiryClientControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryClientControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryClientControllerSearchV1(params: InquiryClientControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.inquiryClientControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<InquiryDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `inquiryClientControllerCreateV1()` */
  static readonly InquiryClientControllerCreateV1Path = '/api/v1/inquiries/client';

  /**
   * 문의 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryClientControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryClientControllerCreateV1$Response(params: InquiryClientControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = inquiryClientControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryClientControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inquiryClientControllerCreateV1(params: InquiryClientControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.inquiryClientControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `inquiryClientControllerFindByIdV1()` */
  static readonly InquiryClientControllerFindByIdV1Path = '/api/v1/inquiries/client/{id}';

  /**
   * 문의 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inquiryClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryClientControllerFindByIdV1$Response(params: InquiryClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
    const obs = inquiryClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 문의 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inquiryClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inquiryClientControllerFindByIdV1(params: InquiryClientControllerFindByIdV1$Params, context?: HttpContext): Observable<InquiryDto> {
    const resp = this.inquiryClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InquiryDto>): InquiryDto => r.body)
    );
  }

}
